import { formatDate, formatTime } from '@/libs/date/date'
import {
  MS_PER_SECOND,
  SECONDS_PER_MINUTE,
  MINUTES_PER_HOUR,
  HOURS_PER_DAY,
} from './types'

/**
 * Calculate time difference and return human-readable string
 * @param createdDate
 */
export function getTimeAgo(createdDate: Date): string {
  const now = new Date()
  const diffMs = now.getTime() - createdDate.getTime()
  const diffMinutes = Math.floor(diffMs / (MS_PER_SECOND * SECONDS_PER_MINUTE))
  const diffHours = Math.floor(
    diffMs / (MS_PER_SECOND * SECONDS_PER_MINUTE * MINUTES_PER_HOUR)
  )
  const diffDays = Math.floor(
    diffMs /
      (MS_PER_SECOND * SECONDS_PER_MINUTE * MINUTES_PER_HOUR * HOURS_PER_DAY)
  )

  if (diffMinutes < MINUTES_PER_HOUR) {
    return `${diffMinutes} min ago`
  } else if (diffHours < HOURS_PER_DAY) {
    return `${diffHours} hr ago`
  } else {
    return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`
  }
}

/**
 *
 * @param datetime
 */
export function renderTextReceivedStr(
  datetime: string | null | undefined
): string {
  if (!datetime) {
    return 'Received N/A'
  }

  // Ensure the timestamp is treated as UTC if it doesn't have timezone info
  const normalizedDatetime = datetime.endsWith('Z') ? datetime : `${datetime}Z`
  const createdDate = new Date(normalizedDatetime)
  const dateStr = formatDate(createdDate)
  const timeStr = formatTime(createdDate)
  const timeAgo = getTimeAgo(createdDate)

  return `Received ${dateStr} ${timeStr} (${timeAgo})`
}
